import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["showFileList", "className", "fileListItemClassName", "style", "autoUpload", "multiple", "disabled", "action", "headers", "data", "withCredentials", "drag", "accept", "beforeUpload", "onRemove", "onChange", "showFullFileName", "externalUpload", "externalCancel", "extraPropToFlowjs", "acceptFileType", "directory", "uploadTitle", "uploadButtonName", "onClose", "maxFileSize", "onUpload", "config", "uploadInstruction", "description"];
import React, { useState, useRef } from "react";
import ClassNames from "classnames";
import UploadList from "./UploadList";
import AjaxUpload from "./AjaxUpload";
import { Button } from '../button';
import { getFileItem, removeFile } from "./utils";
import { KEY_VALUES, mergeRefs } from '../utils';
;
var defaultProps = {
  headers: {},
  color: "default",
  showFileList: true,
  autoUpload: false,
  drag: true,
  showFullFileName: true,
  onRemove: function onRemove(targetItem, newFileList) {},
  onProgress: function onProgress(targetItem) {},
  onError: function onError(targetItem) {},
  onChange: function onChange(file, fileList) {}
};
var Upload = /*#__PURE__*/React.forwardRef(function (parmprops, ref) {
  var props = Object.assign({}, defaultProps, parmprops);
  var showFileList = props.showFileList,
    className = props.className,
    fileListItemClassName = props.fileListItemClassName,
    style = props.style,
    autoUpload = props.autoUpload,
    multiple = props.multiple,
    disabled = props.disabled,
    action = props.action,
    headers = props.headers,
    data = props.data,
    withCredentials = props.withCredentials,
    drag = props.drag,
    accept = props.accept,
    beforeUpload = props.beforeUpload,
    onRemove = props.onRemove,
    onChange = props.onChange,
    showFullFileName = props.showFullFileName,
    externalUpload = props.externalUpload,
    externalCancel = props.externalCancel,
    extraPropToFlowjs = props.extraPropToFlowjs,
    acceptFileType = props.acceptFileType,
    directory = props.directory,
    _props$uploadTitle = props.uploadTitle,
    uploadTitle = _props$uploadTitle === void 0 ? '' : _props$uploadTitle,
    _props$uploadButtonNa = props.uploadButtonName,
    uploadButtonName = _props$uploadButtonNa === void 0 ? 'Upload' : _props$uploadButtonNa,
    onClose = props.onClose,
    maxFileSize = props.maxFileSize,
    onUpload = props.onUpload,
    _props$config = props.config,
    config = _props$config === void 0 ? {
      type: "inline",
      trigger: false,
      size: true
    } : _props$config,
    _props$uploadInstruct = props.uploadInstruction,
    uploadInstruction = _props$uploadInstruct === void 0 ? "" : _props$uploadInstruct,
    description = props.description,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var uploadInner = useRef();
  var uploadRef = React.useRef(null);
  var announceRef = React.useRef('');
  var fileListRef = React.useRef([]);
  var existErrorRef = React.useRef(false);
  var _useState = useState([]),
    listValue = _useState[0],
    setListValue = _useState[1];
  var _useState2 = useState([]),
    fileList = _useState2[0],
    setfileList = _useState2[1];
  var updateFocusAfterDelete = function updateFocusAfterDelete(index) {
    var deleteIcons = uploadRef.current.querySelectorAll('.Appkit4-icon.icon-close-outline');
    if (deleteIcons && deleteIcons.length > 0 && index > 0) {
      (deleteIcons === null || deleteIcons === void 0 ? void 0 : deleteIcons[index - 1]) && (deleteIcons === null || deleteIcons === void 0 ? void 0 : deleteIcons[index - 1]).focus();
    } else if (deleteIcons && index === 0) {
      if (deleteIcons.length <= 2) {
        var attachButton = uploadRef.current.querySelector('.ap-fileupload-drop-btn');
        attachButton && attachButton.focus();
      } else {
        (deleteIcons === null || deleteIcons === void 0 ? void 0 : deleteIcons[1]) && (deleteIcons === null || deleteIcons === void 0 ? void 0 : deleteIcons[1]).focus();
      }
    }
  };
  var returnMessage = function returnMessage(status) {
    var message = '';
    switch (status) {
      case 'ready':
      case 'uploading':
        message = ', ready to upload.';
        break;
      case 'error':
        message = ', we have encountered unexpected problems, please try again.';
        break;
      case 'success':
        message = ', upload successful.';
        break;
      default:
        break;
    }
    return message;
  };
  var addUploadMessage = function addUploadMessage() {
    setTimeout(function () {
      if (uploadRef.current && uploadRef.current.querySelector('#messageContent') && uploadRef.current.querySelector('#messageInformation')) {
        var uploadElement = uploadRef.current;
        var messageContent = uploadElement.querySelector('#messageContent');
        var messageInformation = uploadElement.querySelector('#messageInformation');
        messageInformation.innerHTML = '';
        var elementInformation = document.createElement("div");
        elementInformation.setAttribute('aria-live', 'assertive');
        messageInformation.appendChild(elementInformation);
        // Only keep the new announce
        (!props.autoUpload && props.multiple || props.autoUpload && props.multiple) && fileList.map(function (item) {
          if (announceRef.current.indexOf("" + item.name + returnMessage('ready')) > -1) messageContent.innerHTML = messageContent.innerHTML.replace("" + item.name + returnMessage('ready'), '');
          if (announceRef.current.indexOf("" + item.name + returnMessage('uploading')) > -1) messageContent.innerHTML = messageContent.innerHTML.replace("" + item.name + returnMessage('uploading'), '');
          if (announceRef.current.indexOf("" + item.name + returnMessage('error')) > -1) messageContent.innerHTML = messageContent.innerHTML.replace("" + item.name + returnMessage('error'), '');
          if (announceRef.current.indexOf("" + item.name + returnMessage('success')) > -1) messageContent.innerHTML = messageContent.innerHTML.replace("" + item.name + returnMessage('success'), '');
          if (messageContent.innerHTML.indexOf("" + item.name + returnMessage('ready')) > -1 && messageContent.innerHTML.indexOf("" + item.name + returnMessage('error')) < 0 && messageContent.innerHTML.indexOf("" + item.name + returnMessage('success')) < 0) messageContent.innerHTML += "" + item.name + returnMessage('success');
        });
        if (props.autoUpload && fileList.length === 1) {
          var name = fileList[0].name;
          if (messageContent.innerHTML.indexOf("" + name + returnMessage('success')) > -1 && messageContent.innerHTML.indexOf("" + name + returnMessage('error')) < 0 && messageContent.innerHTML.indexOf("" + name + returnMessage('ready')) < 0) messageContent.innerHTML = "" + name + returnMessage('ready') + name + returnMessage('success');
          if (messageContent.innerHTML.indexOf("" + name + returnMessage('error')) > -1 && messageContent.innerHTML.indexOf("" + name + returnMessage('success')) < 0 && messageContent.innerHTML.indexOf("" + name + returnMessage('ready')) < 0) messageContent.innerHTML = "" + name + returnMessage('ready') + name + returnMessage('error');
        }
        if (!props.autoUpload || props.autoUpload && props.multiple) announceRef.current += messageContent.innerHTML;
        if (!props.autoUpload) {
          var regex = new RegExp(returnMessage('success'), "g");
          if (messageContent.innerHTML.indexOf("" + returnMessage('error')) > -1 || existErrorRef.current) elementInformation.innerHTML = 'Upload error, review items.';else if ((messageContent.innerHTML.match(regex) || []).length > 1) elementInformation.innerHTML = 'Upload complete.';else if ((messageContent.innerHTML.match(regex) || []).length === 1) elementInformation.innerHTML = 'Uploads complete.';
        } else {
          elementInformation.innerHTML = messageContent.innerHTML;
        }
        messageContent.innerHTML = '';
        existErrorRef.current = false;
      }
    }, 0);
  };
  var clearListRef = function clearListRef() {
    announceRef.current = '';
    existErrorRef.current = false;
    fileListRef.current = [];
    setListValue([]);
  };
  React.useEffect(function () {
    return function () {
      clearListRef();
    };
  }, []);
  var removeListByName = function removeListByName(file) {
    setListValue(function (list) {
      return list.filter(function (item) {
        return item.name !== file.name;
      });
    });
  };

  /**
  * @param {FileModel} file - extended file object
  */
  var onStart = function onStart(file) {
    if (!props.multiple) {
      fileList.splice(0);
    }
    fileList.push(file);
    props.onChange(file, fileList);
    setfileList([].concat(fileList));
  };

  /**
   * @param {Object} e - progress information
   * @param {FileModel} file - extended file object
   */
  var onProgress = function onProgress(percent, file) {
    var targetItem = getFileItem(file, fileList);
    if (targetItem) {
      targetItem.status = "uploading";
      targetItem.percent = percent;
      props.onProgress && props.onProgress(targetItem);
      setfileList([].concat(fileList));
    }
  };

  /**
   * @param {Error} error - error object
   * @param {FileModel} file - extended file object
   */
  var onError = function onError(error, file) {
    // let fileList = this.state.fileList;
    var targetItem = getFileItem(file, fileList);
    if (targetItem) {
      targetItem.error = error;
      targetItem.status = "error";
      existErrorRef.current = true;
      setfileList([].concat(fileList));
      if (!multiple) fileListRef.current.splice(0, 1);
      !props.autoUpload && fileListRef.current.push(file);
      if (props.autoUpload && fileListRef.current.length < fileList.length || !props.autoUpload && fileListRef.current.length === fileList.length) addUploadMessage();
      props.onError(targetItem);
      props.onChange(targetItem, fileList);
    } else if (error && file && typeof error === 'string' && error !== '') {
      props.onError({
        error: error,
        file: file
      });
    }
  };
  var onUnaccept = function onUnaccept(file) {
    // let { fileList } = this.state;

    file.error = "_unaccept_";
    file.status = "error";
    if (!props.multiple) {
      fileList = [];
    }
    fileList.push(file);
    // this.setState({ fileList: fileList });
    setfileList([].concat(fileList));
  };

  /**
   * @param {Object} response - server response
   * @param {FileModel} file - extended file object
   */
  var onSuccess = function onSuccess(response, file) {
    try {
      if (typeof response === 'string') {
        response = JSON.parse(response);
      }
    } catch (e) {
      /* do nothing */
    }
    var targetItem = getFileItem(file, fileList);

    // removed
    if (!targetItem) {
      return;
    }
    targetItem.status = "success";
    targetItem.response = response;
    setfileList([].concat(fileList));
    if (!multiple) fileListRef.current.splice(0, 1);
    fileListRef.current.push(file);
    if (fileListRef.current.length === fileList.length || props.autoUpload || !props.autoUpload && !props.multiple) addUploadMessage();
    props.onSuccess && props.onSuccess(targetItem);
    props.onChange(targetItem, fileList);
  };

  /**
   * Remove file call back funtion
   * @param {FileModel} file - extended file object
   */
  var handleRemoveFile = function handleRemoveFile(file) {
    //get current file of filelist
    var targetItem = getFileItem(file, fileList);
    //cancel request
    uploadInner.current.cancel(file.uid);
    if (targetItem) {
      targetItem.status = "deleted";
      var newFileList = removeFile(file, fileList);
      updateFocusAfterDelete(Array.prototype.indexOf.call(fileList, file));
      setfileList([].concat(newFileList));
      props.onRemove(targetItem, newFileList);
      props.onChange(targetItem, newFileList);
      removeListByName(file);
    }
  };
  var handleAllRemoveFile = function handleAllRemoveFile() {
    // let fileList = this.state.fileList;
    setfileList([]);
    clearListRef();
    announceRef.current = '';
    var newFileList = fileList.map(function (file) {
      file.status = "deleted";
      return file;
    });
    props.onRemove(newFileList, []);
    props.onChange(newFileList, []);
  };
  var handleDeleteAll = function handleDeleteAll(event) {
    var key = event.key;
    if ((key === KEY_VALUES.ENTER || key === KEY_VALUES.SPACE) && !props.disabled) {
      handleAllRemoveFile();
    }
  };

  /**
   * API: Upload file on trigger
   */
  var submit = function submit() {
    if (fileList && fileList.length) {
      if (action) {
        fileList.filter(function (file) {
          return file.status === "ready";
        }).forEach(function (file) {
          uploadInner.current.upload(file);
        });
      }
      onUpload && onUpload(fileList);
    }
  };

  /**
   *  API: cancel current upload
   *
   */
  var cancel = function cancel() {
    fileList.filter(function (file) {
      return file.status === "uploading";
    }).forEach(function (file) {
      uploadInner.current.cancel(file.uid);
    });
  };

  /**
   * Retry upload
   * @param {FileModel} file - extended file object
   * again upload
   */
  var retryUpload = function retryUpload(file) {
    if (file) {
      setfileList([].concat(fileList));
      uploadInner.current.upload(file);
    }
  };
  var renderUploadList = function renderUploadList() {
    return /*#__PURE__*/React.createElement(UploadList, {
      showFullFileName: props.showFullFileName,
      fileListItemClassName: props.fileListItemClassName,
      files: fileList,
      onRemove: handleRemoveFile,
      autoUpload: props.autoUpload,
      multiple: props.multiple,
      retryUpload: retryUpload,
      config: config,
      errorMessage: props.errorMessage
    });
  };
  var generateUploaderFragment = function generateUploaderFragment() {
    var uploaderProps = {
      autoUpload: props.autoUpload,
      action: props.action,
      multiple: props.multiple,
      beforeUpload: props.beforeUpload,
      withCredentials: props.withCredentials,
      headers: props.headers,
      disabled: props.disabled,
      data: props.data,
      accept: props.accept,
      drag: props.drag,
      onStart: onStart,
      onProgress: onProgress,
      onSuccess: onSuccess,
      onError: onError,
      onUnaccept: onUnaccept,
      onRemove: handleRemoveFile,
      externalUpload: props.externalUpload,
      externalCancel: props.externalCancel,
      extraPropToFlowjs: props.extraPropToFlowjs,
      ref: uploadInner,
      acceptFileType: props.acceptFileType,
      directory: props.directory,
      mode: props.mode,
      maxFileSize: maxFileSize,
      config: config,
      listRef: listValue,
      description: props.description
    };
    var trigger = props.children;
    return (
      /*#__PURE__*/
      // @ts-ignore
      React.createElement(AjaxUpload, _extends({
        key: "AjaxUpload"
      }, uploaderProps), trigger)
    );
  };
  var containerClass = ClassNames("ap-fileupload", props.className, {
    "ap-fileupload-modal": config.type === 'modal'
  });
  var titleClass = ClassNames("ap-fileupload-title", props.className, {
    "title-modal": config.type === 'modal',
    "title-inline": config.type !== 'modal'
  });
  var instructionClass = ClassNames("ap-fileupload-instruction", {
    "instruction-modal": config.type === 'modal' && !config.trigger,
    "instruction-modal-button": config.type === 'modal' && config.trigger,
    "instruction-inline": config.type !== 'modal'
  });
  var uploadList, uploader;
  uploader = generateUploaderFragment();
  // Generate upload list section
  if (props.showFileList && fileList.length) {
    uploadList = renderUploadList();
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    style: props.style,
    ref: mergeRefs(ref, uploadRef),
    className: containerClass
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: "ap-fileupload-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: titleClass
  }, /*#__PURE__*/React.createElement("span", null, uploadTitle)), /*#__PURE__*/React.createElement("div", {
    className: instructionClass
  }, uploadInstruction), uploader, uploadList, /*#__PURE__*/React.createElement("div", {
    className: "ap-fileupload-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ap-fileupload-footer-delete-attachment"
  }, fileList && fileList.length > 0 && /*#__PURE__*/React.createElement("span", {
    role: "button",
    onClick: handleAllRemoveFile,
    onKeyDown: handleDeleteAll,
    tabIndex: 0
  }, "Delete all attachments")), config.trigger && /*#__PURE__*/React.createElement("div", {
    className: "ap-fileupload-footer-btn"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: submit,
    disabled: !fileList.length
  }, uploadButtonName))), /*#__PURE__*/React.createElement("div", {
    id: "messageInformation",
    style: {
      opacity: 0,
      width: '0px',
      height: '0px'
    }
  }), config.type === 'modal' && /*#__PURE__*/React.createElement("div", {
    className: "ap-fileupload-action"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      onClose && onClose(fileList);
    },
    className: "ap-fileupload-title-close",
    "aria-label": "close",
    type: "button"
  }, /*#__PURE__*/React.createElement("span", {
    className: "Appkit4-icon icon-close-outline"
  })))));
});
export default Upload;